export class OrderShippingMethod {
    mailClass: string;
    mailServiceName: string;
    trackingNumber: string;
    externalVendorId: string;
}